import { ApplicationType } from "./ApplicationType";

export const ApplicationTypeDisplay: Record<ApplicationType, string> = {
  [ApplicationType.HWRC]: "HWRC",
  [ApplicationType.MyAccess]: "My Access",
  [ApplicationType.Whitespace]: "Whitespace"
};
